<template>
  <div :class="[$route.params.course_id ? 'course_preview_main_holder' : '']">
    <!-- content info -->
    <div
      class="preview_collapse"
      @click="previewCollapseInfo = !previewCollapseInfo"
    >
      <h4>Course info</h4>
      <span
        class="material-icons downarrow"
        :class="[previewCollapseInfo ? 'rotate' : '']"
        >keyboard_arrow_down</span
      >
    </div>
    <template v-if="addCoursework || courseWorkedit ? false : true">
      <vs-row
        class="light_blue_holder course_content p-4"
        v-if="courseData"
        :class="[previewCollapseInfo ? 'show' : 'hide']"
      >
        <vs-col vs-lg="9" vs-sm="12" class="col_styling flex">
          <div class="course_image">
            <img
              v-if="Object.keys(courseData.courseImage).length > 0"
              :src="courseData.courseImage.file_path"
              alt="course"
              class="w-full"
            />
            <img
              v-else
              src="https://scoolio-files.s3.ap-south-1.amazonaws.com/Scoolio/Students+watching+webinar+on+computer.jpg"
              alt="course_image"
            />
          </div>
          <div class="inner_course_content">
            <span class="material-icons-outlined">collections_bookmark</span>
            <div class="pl-2">
              <h4 class="mb-3">{{ courseData.name }}</h4>
              <p class="mb-1">
                Subject:
                <strong>{{
                  courseData.has_all_subject
                    ? "General"
                    : getAllSubject(courseData.subjects)
                }}</strong>
              </p>
              <p class="mb-1">
                Total Price:
                <strong
                  >&#163;<span class="pl-1">{{
                    courseData.coursePaymentSetting.total_price
                  }}</span></strong
                >
              </p>
              <p class="desc">{{ courseData.description }}</p>
            </div>
          </div>
        </vs-col>
        <vs-col vs-lg="3" vs-sm="12" class="col_styling pt-2">
          <iframe
            width="100%"
            height="180"
            :src="courseData.courseVideo.file_path"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </vs-col>
        <vs-col vs-w="12">
          <div class="overall_detail_holder hidden">
            <div class="each_data">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 21V19.4C6.43333 19.1333 6.825 18.8375 7.175 18.5125C7.525 18.1875 7.825 17.8417 8.075 17.475C8.325 17.1083 8.51667 16.7167 8.65 16.3C8.78333 15.8833 8.85 15.45 8.85 15C8.85 14.7833 8.8375 14.575 8.8125 14.375C8.7875 14.175 8.75 13.9667 8.7 13.75H6V12.25H7.95C7.3 11.35 6.85417 10.5542 6.6125 9.8625C6.37083 9.17083 6.25 8.46667 6.25 7.75C6.25 6.28333 6.75833 5.04167 7.775 4.025C8.79167 3.00833 10.0333 2.5 11.5 2.5C12.5833 2.5 13.5625 2.77083 14.4375 3.3125C15.3125 3.85417 15.9583 4.58333 16.375 5.5L15 6.075C14.7 5.44167 14.2292 4.9375 13.5875 4.5625C12.9458 4.1875 12.25 4 11.5 4C10.4667 4 9.58333 4.3625 8.85 5.0875C8.11667 5.8125 7.75 6.7 7.75 7.75C7.75 8.4 7.88333 9.0375 8.15 9.6625C8.41667 10.2875 8.95 11.15 9.75 12.25H14V13.75H10.225C10.275 13.9667 10.3083 14.1833 10.325 14.4C10.3417 14.6167 10.35 14.8167 10.35 15C10.35 15.8833 10.1583 16.7083 9.775 17.475C9.39167 18.2417 8.90833 18.9167 8.325 19.5H14C14.6333 19.5 15.1917 19.3333 15.675 19C16.1583 18.6667 16.5083 18.125 16.725 17.375L18.025 18.025C17.8083 19.0083 17.3042 19.75 16.5125 20.25C15.7208 20.75 14.8833 21 14 21H6Z"
                  fill="#555262"
                />
              </svg>
              <div class="pl-2">
                <strong
                  >£{{ courseData.coursePaymentSetting.total_price }}</strong
                >
                <p>Price</p>
              </div>
            </div>
            <div class="each_data">
              <span class="material-icons-outlined">alarm</span>
              <div class="pl-2">
                <strong>{{ session_duration || "Not Available" }}</strong>
                <p>Session Duration</p>
              </div>
            </div>
            <div class="each_data">
              <span class="material-icons-outlined">event</span>
              <div class="pl-2">
                <strong>{{
                  courseData.courseScheduleSetting
                    ? courseData.courseScheduleSetting.no_of_sessions
                    : "Not Available"
                }}</strong>
                <p>Number of Sessions</p>
              </div>
            </div>
            <div class="each_data">
              <span class="material-icons-outlined">rotate_right</span>
              <div class="pl-2">
                <strong>{{ session_frequency || "Not Available" }} </strong>
                <p>Session Frequency</p>
              </div>
            </div>
            <div class="each_data">
              <span class="material-icons-outlined">insert_invitation</span>
              <div class="pl-2">
                <strong>Not Available </strong>
                <p>Start Date</p>
              </div>
            </div>
            <div class="each_data">
              <span class="material-icons-outlined">insert_invitation</span>
              <div class="pl-2">
                <strong>Not Available</strong>
                <p>End Date</p>
              </div>
            </div>
            <div class="each_data">
              <div class="flex items-center">
                <div
                  class="cstm-img-holder"
                  v-for="(tutor, index) in courseData.tutors"
                  :key="index"
                >
                  <vs-tooltip
                    :text="`${tutor.first_name} ${tutor.last_name}`"
                    position="top"
                    color="primary"
                  >
                    <img
                      v-if="tutor.picture"
                      data-v-b18e1656=""
                      :src="tutor.picture"
                      alt="user-img"
                      width="20"
                      height="20"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                    <img
                      v-else
                      data-v-b18e1656=""
                      src="@/assets/images/pages/user-circle-solid.svg"
                      alt="user-img"
                      width="20"
                      height="20"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                  </vs-tooltip>
                </div>
              </div>
            </div>
          </div>
        </vs-col>
      </vs-row>

      <!-- lessons -->
      <div class="border_btm py-4" v-click-outside="outsideDropdown">
        <h4 class="mb-4">Lesson(s)</h4>
        <div class="lessons_holder">
          <div class="listing_holder">
            <vs-collapse class="question_card">
              <draggable
                :list="lessonArray"
                class="py-2 cursor-move"
                handle=".handle1"
              >
                <template v-for="(item, index) in lessonArray">
                  <vs-collapse-item
                    v-if="true"
                    :class="[
                      index === editLessonIndex ? 'opened_collapse' : '',
                    ]"
                    :open="index === editLessonIndex"
                    :key="index"
                  >
                    <div
                      class="header flex-flex-wrap justify-between items-center"
                      slot="header"
                      @click="fetchParticularLessonData(index, item)"
                    >
                      <div class="drag_holder handle1">
                        <span class="material-icons-outlined"
                          >drag_indicator</span
                        >
                      </div>
                      <p class="lesson_heading">{{ item.name }}</p>
                      <vs-button
                        type="border"
                        :disabled="!item.can_delete"
                        @click="openLessonDeletePopup(item.id)"
                        class="material-icons-outlined inline-block"
                        icon-pack="feather"
                        color="danger"
                        icon="icon-trash-2"
                      ></vs-button>
                    </div>
                    <!-- <div v-if="item.topics">
                      <pre>{{item}}</pre>
                    </div> -->
                    <div class="each_topic_list">
                      <div
                        class="w-full topic_name"
                        v-if="item.topics.length > 0"
                      >
                      <draggable
                            :list="item.topics"
                            class="w-full py-2 cursor-move"
                            handle=".handle11"
                          >
                        <div
                          :class="[
                            activeTopic == index1 && editLessonIndex == index
                              ? 'active'
                              : '',
                          ]"
                          @click="TopicdetailsView(lessonTopic, index1, index)"
                          v-for="(lessonTopic, index1) in item.topics"
                          :key="index1"
                          class="
                            each_topic_holder
                            py-2
                          "
                        >

                            <div class="flex justify-between items-center">
                              <div class="mr-2 handle11">
                                <span class="material-icons-outlined"
                                  >drag_indicator</span
                                >
                              </div>
                              <div style="width: 50px">
                                <div
                                  class="icon_holder"
                                  v-if="lessonTopic.topicFiles.length > 0"
                                >
                                  <span
                                    v-if="
                                      video_array.includes(
                                        lessonTopic.topicFiles[0].file.file_type
                                      )
                                    "
                                    class="material-icons-outlined"
                                    >play_arrow</span
                                  >
                                  <span
                                    v-if="
                                      audio_array.includes(
                                        lessonTopic.topicFiles[0].file.file_type
                                      ) ||
                                      lessonTopic.topicFiles[0].file.file_type.includes(
                                        'audio'
                                      )
                                    "
                                    class="material-icons-outlined"
                                    >mic_none</span
                                  >
                                  <span
                                    v-if="
                                      lessonTopic.topicFiles[0].file.file_type.includes(
                                        'application/pdf'
                                      )
                                    "
                                    class="material-icons-outlined"
                                    >folder_special</span
                                  >
                                </div>
                                <div
                                  class="icon_holder"
                                  v-if="lessonTopic.topicFiles.length == 0"
                                >
                                  <span
                                    v-if="lessonTopic.topic_type == 3"
                                    class="material-icons-outlined"
                                    >bookmarks</span
                                  >
                                  <span
                                    v-if="lessonTopic.topic_type == 4"
                                    class="material-icons-outlined"
                                    >rule</span
                                  >
                                  <span
                                    v-if="lessonTopic.topic_type == 6"
                                    class="material-icons-outlined"
                                    >title</span
                                  >
                                </div>
                              </div>
                              <div class="topic_inner_name">
                                {{ lessonTopic.name }}
                              </div>
                            </div>

                        </div>
                      </draggable>
                      </div>
                    </div>
                  </vs-collapse-item>
                </template>
              </draggable>
            </vs-collapse>
            <div class="flex flex-wrap justify-between items-center">
              <div
                class="create_btn lesson_create_btn m-2"
                @click="AddLesson"
                v-if="counter !== 6"
              >
                <span class="material-icons">add_circle_outline</span>
                <span class="pl-2">Create Lesson</span>
              </div>
              <vs-tooltip color="primary" class="m-2"
                text="Import Lessons"
              >
                <vs-button
                  icon="folder_special"
                  class="icon_large_btn"
                  color="primary"
                  type="border"
                  @click="isLessonImportModal = !isLessonImportModal"
                  ></vs-button
                >
              </vs-tooltip>
            </div>
          </div>
          <div class="detail_holder">
            <div class="grey_border px-6 py-4" v-if="!isTopicDetailsView">
              <div style="border-bottom: 1px solid #cecece">
                <div class="flex mb-2">
                  <label>Lesson Title</label>
                  <vs-input
                    :disabled="counter == 6 ? true : false"
                    @input="addToLesson"
                    v-model="lessonPayload[editLessonIndex].name"
                    type="text"
                    placeholder="Enter lesson title here"
                    class="w-full"
                  />
                </div>
                <div class="flex mb-2">
                  <label>Lesson Description</label>
                  <vs-textarea
                    :disabled="counter == 6 ? true : false"
                    @keyup="addToLesson"
                    v-model="lessonPayload[editLessonIndex].description"
                    placeholder="Enter lesson description here"
                    class="w-full"
                  >
                  </vs-textarea>
                </div>
              </div>
              <div class="each_topic_list">
                <table
                  class="cstm_vuexy_table w-full"
                  v-if="lessonPayload[editLessonIndex].topics.length > 0"
                >
                  <tr
                    v-for="(lessonTopic, index) in lessonPayload[
                      editLessonIndex
                    ].topics"
                    :key="index"
                  >
                    <td
                      style="width: 50px"
                      v-if="lessonTopic.topicFiles.length == 0"
                    >
                      <div class="icon_holder">
                        <span
                          v-if="lessonTopic.topic_type == 3"
                          class="material-icons-outlined"
                          >bookmarks</span
                        >
                        <span
                          v-if="lessonTopic.topic_type == 4"
                          class="material-icons-outlined"
                          >rule</span
                        >
                        <span
                          v-if="lessonTopic.topic_type == 6"
                          class="material-icons-outlined"
                          >title</span
                        >
                      </div>
                    </td>
                    <td
                      style="width: 50px"
                      v-if="lessonTopic.topicFiles.length > 0"
                    >
                      <div class="icon_holder">
                        <span
                          v-if="
                            video_array.includes(
                              lessonTopic.topicFiles[0].file.file_type
                            )
                          "
                          class="material-icons-outlined"
                          >play_arrow</span
                        >
                        <span
                          v-if="
                            audio_array.includes(
                              lessonTopic.topicFiles[0].file.file_type
                            ) ||
                            lessonTopic.topicFiles[0].file.file_type.includes(
                              'audio'
                            )
                          "
                          class="material-icons-outlined"
                          >mic_none</span
                        >

                        <span
                          v-if="
                            lessonTopic.topicFiles[0].file.file_type.includes(
                              'application/pdf'
                            )
                          "
                          class="material-icons-outlined"
                          >folder_special</span
                        >
                      </div>
                    </td>
                    <td>{{ lessonTopic.name }}</td>
                    <td>{{ lessonTopic.description }}</td>
                    <!-- <td v-if="counter !== 6" style="width: 20px">
                      <span
                        style="cursor: pointer"
                        class="material-icons-outlined"
                        @click="editTopic(editLessonIndex, lessonTopic)"
                        >edit</span
                      >
                    </td> -->
                    <td v-if="counter !== 6" style="width: 20px">
                      <vs-tooltip text="Detach" color="primary">
                        <span
                          style="cursor: pointer"
                          class="material-icons-outlined"
                          @click="
                            deleteTopicFromLesson(editLessonIndex, lessonTopic.id)
                          "
                          >link_off</span
                        >
                      </vs-tooltip>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="added_section" v-if="counter !== 6">
                <div class="flex w-full px-4 pt-4 pb-2">
                  <span class="material-icons">add_circle_outline</span>
                  <span class="pl-2">Add</span>
                </div>
                <ul class="icon_list">
                  <li @click="fetchTopicList('Video')">
                    <vs-tooltip text="Add Video" position="bottom">
                      <span class="material-icons-outlined">videocam</span>
                    </vs-tooltip>
                  </li>
                  <li @click="fetchTopicList('Audio')">
                    <vs-tooltip text="Add Audio" position="bottom">
                      <span class="material-icons-outlined">mic_none</span>
                    </vs-tooltip>
                  </li>
                  <li
                    @click="fetchCourseworkExamList('Coursework')"
                    v-if="
                      courseData &&
                      courseData.courseContentSetting !== null &&
                      courseData.courseContentSetting.has_coursework
                    "
                  >
                    <vs-tooltip text="Add Coursework" position="bottom">
                      <span class="material-icons-outlined">bookmarks</span>
                    </vs-tooltip>
                  </li>
                  <li
                    @click="fetchCourseworkExamList('Exam')"
                    v-if="
                      courseData &&
                      courseData.courseContentSetting !== null &&
                      courseData.courseContentSetting.has_exam
                    "
                  >
                    <vs-tooltip text="Add Exam" position="bottom">
                      <span class="material-icons-outlined">rule</span>
                    </vs-tooltip>
                  </li>
                  <!-- <li @click="fetchTopicList('Report')">
                    <vs-tooltip text="Add Report" position="bottom">
                      <span class="material-icons-outlined">summarize</span>
                    </vs-tooltip>
                  </li> -->
                  <li @click="fetchTopicList('Note')">
                    <vs-tooltip text="Add Note" position="bottom">
                      <span class="material-icons-outlined">description</span>
                    </vs-tooltip>
                  </li>
                  <li @click="fetchTopicList('File')">
                    <vs-tooltip text="Add File" position="bottom">
                      <span class="material-icons-outlined"
                        >folder_special</span
                      >
                    </vs-tooltip>
                  </li>
                  <li>
                    <vs-tooltip text="Add Application" position="bottom">
                      <span class="material-icons-outlined">phone_iphone</span>
                    </vs-tooltip>
                  </li>
                </ul>
              </div>
              <!-- <vs-button @click="CreateCourseContent"> Save</vs-button> -->
            </div>
            <div class="grey_border px-6 py-4" v-if="isTopicDetailsView">
              <TopicDetailsView
                v-if="
                  isTopicDetailsView && contentType != 3 && contentType != 4
                "
                :isTopicDetailsView="isTopicDetailsView"
                :contentType="contentType"
                :content="content"
              />
              <CourseExamPreviewComponent
                v-if="
                  isTopicDetailsView && (contentType == 3 || contentType == 4)
                "
                :preview="preview"
                :isTopicDetailsView="isTopicDetailsView"
                :contentType="contentType"
                :content="content"
                :flag="flag"
              />
              <div v-if="isTopicDetailsView && contentType == 6">
                <NoteComponentPreview
                  :isTopicDetailsView="isTopicDetailsView"
                  :pdfDetails="content"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <vs-button
        class="block mx-auto mt-4"
        v-if="counter != 6"
        @click="CreateCourseContent"
        >Save & Complete</vs-button
      >
    </template>
    <vs-popup classContent="popup-example"  title="Please Confirm" :active.sync="lessonDeletePopup">
      <h4>Are you sure to delete this lesson from {{ courseData.name }} with all its contents ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="unlinkFromCourse">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="lessonDeletePopup = !lessonDeletePopup">Cancel</vs-button>
      </vs-row>
    </vs-popup>

    <!-- Add video popup -->
    <FileModalComponent
      v-if="filemodalOpen"
      :filemodalOpen="filemodalOpen"
      :fileType="fileType"
      :topic_list="topic_list"
      @createTopic="createTopic"
      @exportToCourse="exportToCourseFile"
      @closePopupFileModal="closePopupFileModal"
      @loadMoreTopic="loadMoreTopic"
    />

    <CourseExamModalComponent
      v-if="addCoursework"
      :fileType="fileType"
      :addCoursework="addCoursework"
      :topic_list="topic_list"
      :course_subject_ids="course_subject_ids"
      :has_course_all_subject="has_course_all_subject"
      @exportToCourse="exportToCourse"
      @closeModal="closeModalCoursework"
      @updatefetchTopic="updatefetchTopic"
      @loadMoreTopicCourse="loadMoreTopicCourse"
    />

    <NoteComponent
      v-if="noteModal"
      :fileType="fileType"
      :noteModal="noteModal"
      :topic_list="topic_list"
      @createTopic="createTopic"
      @exportToCourse="exportToCourseFile"
      @closeModal="closeModal"
      @loadMoreTopic="loadMoreTopic"
    />

    <NoteCreationForCourse
      v-if="noteEditModal"
      fileType="Edit"
      :addNewNote="noteEditModal"
      :editPayload="content"
      @closeCreateModal="closeCreateModal"
      @updateEachTopic="updateEachTopic"
    />
    <EditFileModal
      v-if="fileModaledit"
      :fileType="fileType"
      :fileModaledit="fileModaledit"
      :content="content"
      @updateEachTopic="updateEachTopic"
      @exportToCourse="exportToCourseFile"
      @closeModalEditFile="closeModalEditFile"
    />
    <vs-card
      style="background: #fff; position: relative"
      class="cstm_vx_card p-4"
      v-if="courseWorkedit"
      :class="{ show: courseWorkedit }"
    >
      <div
        slot="header"
        style="border-bottom: 1px solid rgba(0, 0, 0, 0.2)"
        class="flex flex-wrap justify-between items-center pb-5 mb-4"
      >
        <h4>Edit {{ fileType }}</h4>
        <button @click.stop="closeEditModal" class="cc-close-modal">
          &times;
        </button>
      </div>
      <CourseOrExam
        :content="content"
        :type="fileType"
        :assignment_type="fileType == 'Coursework' ? 2 : 4"
        @closeEditModal="closeEditModal"
      />
    </vs-card>
    <vs-popup
      v-if="isLessonImportModal"
      fullscreen
      title="Import Lessons"
      :active.sync="isLessonImportModal"
    >
      <ImportLessonModel
        :subject_ids="course_subject_ids"
        :has_course_all_subject="has_course_all_subject"
        @addToLessonArray="importLesson"
      ></ImportLessonModel>
    </vs-popup>
  </div>
</template>

<script>
import NoteCreationForCourse from '@/views/pages/v1/coursebuilder/components/NoteCreationForCourse.vue'
import draggable from 'vuedraggable'

import CourseOrExam from './AddCourseOrExam.vue'
import EditFileModal from './editFiles.vue'
import TopicDetailsView from './TopicDetailsView.vue'
import NoteComponentPreview from './NoteComponentPreview.vue'

import CourseExamPreviewComponent from './CourseWorkExamPreview.vue'
import FileModalComponent from './ContentFileComponet.vue'
import NoteComponent from './NoteComponent.vue'
import CourseExamModalComponent from './CourseExamModalComponent.vue'
import ImportLessonModel from './Import/ImportLessonModel.vue'
import {
  getTopicList,
  createTopic,
  updateCourseContent,
  updateTopic,
  getCourseContent,
  deleteLessonsFromCourse
} from '@/api/courseBuilder.js'
import { listAssignment } from '@/api/assignment-question'

export default {
  watch: {
    counter () {
      // if (this.counter === 5 || this.counter === 6) {
      this.course_id = this.courseId
      if (this.course_id) {
        this.fetchCourseDetails()
      }
      // }
    }
  },
  mounted () {
    //this.fetchCourseDetails()
  },
  props: {
    courseId: {
      required: true,
      default: null
    },
    counter: {
      required: true,
      default: 0
    },
    preview: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      lessonDeletePopup:false,
      isLessonImportModal: false,
      deleteLessonId: '',
      video_array: [
        'mpeg',
        'mp4',
        'mpg',
        'mpe',
        'qt',
        'mov',
        'mxu',
        'm4u',
        'flv',
        'asf',
        'asx',
        'wmv',
        'wm',
        'wmx',
        'avi',
        'ogv',
        'movie'
      ],
      audio_array: [
        'au',
        'snd',
        'mid',
        'midi',
        'kar',
        'mpga',
        'mp2',
        'mp3',
        'aif',
        'aiff',
        'aifc',
        'm3u',
        'wma',
        'wax',
        'ram',
        'ra',
        'wav'
      ],
      image_array: [
        'bmp',
        'cgm',
        'gif',
        'ief',
        'jpeg',
        'jpg',
        'jpe',
        'png',
        'svg',
        'tiff',
        'tif',
        'djvu',
        'djv',
        'wbmp',
        'ras',
        'ico',
        'pnm',
        'pbm',
        'pgm',
        'ppm',
        'rgb',
        'xbm',
        'psd',
        'xpm',
        'xwd'
      ],
      allowed: true,
      activeTopic: null,
      flag: 0,
      previewCollapseInfo: true,
      frequencyArray: [
        {
          id: 1,
          name: 'Daily'
        },
        {
          id: 2,
          name: 'Weekly'
        },
        {
          id: 3,
          name: 'Monthly'
        },
        {
          id: 4,
          name: 'Yearly'
        }
      ],
      durationsArray: [
        {
          id: 1,
          name: '15 Min'
        },
        {
          id: 2,
          name: '30 Min'
        },
        {
          id: 3,
          name: '45 Min'
        },
        {
          id: 4,
          name: '60 Min'
        },
        {
          id: 5,
          name: '75 Min'
        },
        {
          id: 6,
          name: '90 Min'
        },
        {
          id: 7,
          name: 'Custom'
        }
      ],
      topic_metadata: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      editIndex: 0,
      editLessonIndex: 0,
      less: false,
      noteEditModal: false,
      contentType: null,
      lessonArray: [
        {
          subjects: [],
          course_id: this.course_id,
          created_at: null,
          description: null,
          has_all_subject: false,
          id: 0,
          is_visible: true,
          name: null,
          no_of_files: null,
          no_of_topics: null,
          platform_customer_id: null,
          slug: null,
          status: false,
          subject_id: null,
          topics: []
        }
      ],
      lessonPayload: [
        {
          id: null,
          name: null,
          description: null,
          has_all_subject: false,
          is_visible: true,
          subjects: [],
          topics: []
        }
      ],
      noteModal: false,
      courseWorkedit: false,
      lessons: [],
      lesson_topic: [],
      fileType: null,
      filemodalOpen: false,

      topic_list: [],
      course_id: this.$route.params.course_id
        ? this.$route.params.course_id
        : null,

      courseData: null,
      addVideo: false,

      addCoursework: false,
      fileModaledit: false,

      customer_id: localStorage.getItem('customer_id'),
      isTopicDetailsView: false,
      content: null,
      session_frequency: null,
      session_duration: null,
      course_subject_ids: [],
      has_course_all_subject: true
    }
  },
  components: {
    draggable,
    FileModalComponent,
    CourseExamModalComponent,
    NoteComponent,
    TopicDetailsView,
    CourseExamPreviewComponent,
    EditFileModal,
    CourseOrExam,
    NoteCreationForCourse,
    NoteComponentPreview,
    ImportLessonModel
  },
  methods: {
    openLessonDeletePopup (lesson_id) {
      this.lessonDeletePopup = true
      this.deleteLessonId = lesson_id
    },
    async unlinkFromCourse () {
      try {
        await deleteLessonsFromCourse(this.customer_id, this.course_id, {lessons: [this.deleteLessonId]})
        this.showSuccessMessage('success', 'Lesson(s) detached from the course', 'success')
      } catch (error) {
        this.showSuccessMessage('danger', 'Something went wrong', 'danger')
      } finally {
        this.fetchCourseDetails()
        this.lessonDeletePopup = !this.lessonDeletePopup
      }
    },
    closeCreateModal () {
      this.noteEditModal = false
    },
    getAllSubject (subjects) {
      let subjectArray = ''
      subjectArray = subjects.map((e) => {
        if (e.subject_name) {
          return e.subject_name
        }
      })
      subjectArray = subjectArray.join(', ')
      return subjectArray
    },
    loadMoreTopicCourse (type) {
      try {
        const payload = {}
        if (type === 'Coursework') {
          payload.assignment_type_id = 2
        } else if (type === 'Exam') {
          payload.assignment_type_id = 4
        }

        listAssignment(
          payload,
          this.customer_id,
          this.topic_metadata.current_page + 1,
          {}
        ).then((data) => {
          this.topic_list.push(...data.data.data.assignmentlist)
          this.topic_metadata = data.data.data.meta
        })
      } catch (error) {
        console.log(error)
      }
    },
    loadMoreTopic (type) {
      try {
        if (this.topic_metadata.has_next) {
          const payload = {}
          if (type === 'Video') {
            payload.topic_type = 1
          } else if (type === 'Audio') {
            payload.topic_type = 2
          } else if (type === 'File') {
            payload.topic_type = 5
          } else if (type === 'Note') {
            payload.topic_type = 6
          }
          this.$vs.loading()
          getTopicList(
            this.customer_id,
            payload,
            this.topic_metadata.current_page + 1
          ).then((data) => {
            this.topic_list.push(...data.data.data.topic)
            this.topic_metadata = data.data.data.meta
            this.$vs.loading.close()
          })
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.$vs.loading.close()
      }
    },
    closeEditModal (dataObj) {
      this.courseWorkedit = false
      dataObj.name = dataObj.title
      dataObj.id = this.content.id
      this.updateEachTopic(dataObj)
    },
    editTopic (index, content) {
      console.log(content)
      if (content.topic_type === 1) {
        this.fileType = 'Video'
      } else if (content.topic_type === 2) {
        this.fileType = 'Audio'
      } else if (content.topic_type === 5) {
        this.fileType = 'File'
      } else if (content.topic_type === 3) {
        this.fileType = 'Coursework'
      } else if (content.topic_type === 4) {
        this.fileType = 'Exam'
      } else if (content.topic_type === 6) {
        this.fileType = 'Note'
      }

      this.content = content

      this.editIndex = index
      if (content.topic_type === 3 || content.topic_type === 4) {
        this.courseWorkedit = true
      } else if (content.topic_type === 6) {
        this.noteEditModal = true
      } else {
        this.fileModaledit = true
      }
    },
    outsideDropdown () {
      this.isTopicDetailsView = false
    },
    async TopicdetailsView (Allcontent, index, lesson_index) {
      this.activeTopic = index
      this.editLessonIndex = lesson_index
      this.contentType = Allcontent.topic_type
      this.content = Allcontent
      this.isTopicDetailsView = true
      this.flag++
    },
    async updatefetchTopic (fileType) {
      const payload = {}
      if (fileType === 'Coursework') {
        payload.assignment_type_id = 2
      } else if (fileType === 'Exam') {
        payload.assignment_type_id = 4
      }

      const { data } = await listAssignment(payload, this.customer_id, 1, {})
      this.topic_list = data.data.assignmentlist
      this.topic_metadata = data.data.meta
    },
    async updatefetchTopicFile (type) {
      const payload = {
        topic_type: type
      }
      const { data } = await getTopicList(this.customer_id, payload, 1)
      this.topic_list = data.data.topic
      this.topic_metadata = data.data.meta
    },
    fetchParticularLessonData (index) {
      this.editLessonIndex = index
      this.activeTopic = null
      this.lessonPayload[index] = this.lessonArray[index]
      this.isTopicDetailsView = false
    },
    deleteTopicFromLesson (index, id) {
      this.lessonPayload[index].topics = this.lessonPayload[
        index
      ].topics.filter((ele) => {
        if (ele.id !== id) return ele
      })
      this.addToLesson()
    },
    closeModal () {
      this.noteModal = false
    },
    closeModalEditFile () {
      this.fileModaledit = false
    },
    closeModalCoursework () {
      this.addCoursework = false
    },
    closePopupFileModal () {
      this.filemodalOpen = false
    },
    async addToLesson () {
      this.addToLessonArray(this)
    },
    addToLessonArray: _.debounce(async (vm) => {
      try {
        vm.$vs.loading()

        vm.lessonArray = vm.lessonArray.map((ele, index) => {
          if (index === vm.editLessonIndex) {
            return vm.lessonPayload[vm.editLessonIndex]
          }
          return ele
        })
        const payload = {
          lessons: [...vm.lessonArray]
        }
        const { data } = await updateCourseContent(
          vm.customer_id,
          vm.courseId,
          payload
        )
        console.log(vm.lessonArray)
        console.log(data.data.course.content)
        console.log(vm.editLessonIndex)
        vm.lessonArray[vm.editLessonIndex].id =
          data.data.course.content[vm.editLessonIndex].id
      } catch (e) {
        console.log(e)
      } finally {
        vm.$vs.loading.close()
      }
    }, 1000),
    async importLesson (lessonObj) {
      try {
        this.$vs.loading()

        this.lessonArray.push(...lessonObj)
        const payload = {
          lessons: this.lessonArray
        }
        const { data } = await updateCourseContent(
          this.customer_id,
          this.courseId,
          payload
        )
        this.lessonArray[this.editLessonIndex].id =
          data.data.course.content[this.editLessonIndex].id
      } catch (e) {
        console.log(e)
      } finally {
        this.isLessonImportModal = false
        this.$vs.loading.close()
      }
    },
    async CreateCourseContent () {
      if (this.lessonArray.length > 0) {
        const payload = {
          lessons: [...this.lessonArray]
        }
        await updateCourseContent(this.customer_id, this.courseId, payload)
        this.$vs.notify({
          title: 'Success',
          text: 'Course created successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.$router.push({
          name: 'courseListing'
        })
      } else {
        this.$vs.notify({
          title: 'warning',
          text: 'Minimum one lesson is must be add',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }
    },
    AddLesson () {
      this.lessonArray.push({
        subjects: [],
        course_id: null,
        created_at: null,
        description: null,
        has_all_subject: false,
        id: null,
        is_visible: true,
        name: null,
        no_of_files: null,
        no_of_topics: null,
        platform_customer_id: null,
        slug: null,
        status: false,
        subject_id: null,
        topics: []
      })
      this.lessonPayload.push({
        id: null,
        name: null,
        description: null,
        has_all_subject: false,
        is_visible: true,
        subjects: [],
        topics: []
      })
      this.editLessonIndex += 1
    },
    exportToCourseFile (exportObj) {
      if (exportObj) {
        this.lesson_topic.push(exportObj)
        this.lessonPayload[this.editLessonIndex].topics.push(exportObj)

        this.addToLesson()
        this.filemodalOpen = false
        this.noteModal = false
      }
    },
    exportToCourse (exportObj, obj2) {
      let exam_count = 0
      let course_works = 0
      exportObj.topic_type = obj2

      this.courseData.content.forEach((element) => {
        element.topics.forEach((topic) => {
          if (topic.topic_type === 4) {
            exam_count = exam_count + 1
          } else if (topic.topic_type === 3) {
            course_works = course_works + 1
          }
        })
      })

      if (this.courseData.courseStructure.course_type.type === 'self_based') {
        exportObj.questions.forEach((ele) => {
          console.log(![6, 3, 4, 5].includes(ele.question_input_type_id))
          if (![6, 3, 4, 5].includes(ele.question_input_type_id)) {
            this.allowed = false
          }
        })
      }

      if (this.allowed) {
        if (exportObj.topic_type === 4) {
          if (this.courseData.courseContentSetting.has_exam) {
            if (exam_count > this.courseData.courseContentSetting.exam_count) {
              this.$vs.notify({
                title: 'Warning',
                text: `The limit of adding Exam was set as ${this.courseData.courseContentSetting.exam_count}`,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })
            }
          }
        }

        if (exportObj.topic_type === 3) {
          if (this.courseData.courseContentSetting.has_coursework) {
            if (
              course_works >
              this.courseData.courseContentSetting.coursework_count
            ) {
              this.$vs.notify({
                title: 'Warning',
                text: `The limit of adding Coursework was set as ${this.courseData.courseContentSetting.coursework_count}`,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })
            }
          }
        }

        this.createTopicForCoursework(exportObj)
      } else {
        this.$vs.notify({
          title: 'Warning',
          text: 'Self Paced courses only allowed that have answers to the questions defined.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }

      this.addCoursework = false
    },
    createTopicForCoursework (dataObj) {
      const payload = {
        ...dataObj,
        courseWork: dataObj.id,
        name: dataObj.title
      }
      console.log('abcde', payload)
      createTopic(this.customer_id, payload).then((result) => {
        this.lesson_topic.push(result.data.data.topic)
        this.lessonPayload[this.editLessonIndex].topics.push(
          result.data.data.topic
        )
        this.addToLesson()
      })
    },
    createTopic (dataObj) {
      console.log(dataObj)
      const payload = {
        ...dataObj
      }
      if (dataObj.topic_type === 6) {
        payload.note = dataObj.note
        payload.name = dataObj.title
      }
      createTopic(this.customer_id, payload).then((data) => {
        this.updatefetchTopicFile(data.data.data.topic.topic_type)
      })
    },
    updateEachTopic (dataObj) {
      console.log(dataObj)
      const payload = {
        ...dataObj
      }
      if (dataObj.topic_type !== 6) {
        if (
          dataObj.assignment_type !== 'Exam' &&
          dataObj.assignment_type !== 'Homework'
        ) {
          // payload.files = dataObj.topicFiles[0].file_id
        } else if (dataObj.assignment_type === 'Exam') {
          payload.topic_type = 4
          payload.courseWork = dataObj.id
        } else if (dataObj.assignment_type === 'Homework') {
          payload.topic_type = 3
          payload.courseWork = dataObj.id
        }
      } else {
        payload.topic_type = 6
      }
      console.log(payload)
      updateTopic(this.customer_id, dataObj.id, payload).then((data) => {
        if (payload.topic_type === 6) {
          this.noteEditModal = false
        } else {
          this.fileModaledit = false
        }

        this.lessonArray[this.editIndex].topics = this.lessonArray[
          this.editIndex
        ].topics.map((ele) => {
          if (ele.id === data.data.data.topic.id) {
            ele = data.data.data.topic
            return ele
          }
          return ele
        })

        this.updatefetchTopicFile(data.data.data.topic.topic_type)
      })
    },
    async fetchCourseworkExamList (type) {
      const payload = {}
      this.fileType = type
      if (type === 'Coursework') {
        payload.assignment_type_id = 2
        this.addCoursework = true
      } else if (type === 'Exam') {
        payload.assignment_type_id = 4
        this.addCoursework = true
      }
      const { data } = await listAssignment(payload, this.customer_id, 1, {})
      this.topic_list = data.data.assignmentlist
      this.topic_metadata = data.data.meta
    },
    async fetchTopicList (type) {
      try {
        this.fileType = type
        const payload = {}
        if (type === 'Video') {
          payload.topic_type = 1
        } else if (type === 'Audio') {
          payload.topic_type = 2
        } else if (type === 'File') {
          payload.topic_type = 5
        } else if (type === 'Note') {
          payload.topic_type = 6
        }
        getTopicList(this.customer_id, payload, 1).then((data) => {
          this.topic_list = data.data.data.topic
          this.topic_metadata = data.data.data.meta
          if (type === 'Video' || type === 'Audio' || type === 'File') {
            this.filemodalOpen = true
          } else if (type === 'Note') {
            this.noteModal = true
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    async fetchCourseDetails () {
      try {
        const { data } = await getCourseContent(
          this.customer_id,
          this.course_id
        )
        this.courseData = data.data.course
        this.courseData.subjects.map((ele) => {
          this.course_subject_ids.push(ele)
        })
        if (this.course_subject_ids.length > 0) {
          this.has_course_all_subject = false
        }
        if (data.data.course.content.length > 0) {
          this.lessonArray = data.data.course.content
          this.lessonPayload[this.editLessonIndex] =
            data.data.course.content[0]
        }
        let duration = []
        let frequency = []
        if (this.courseData.courseScheduleSetting !== null) {
          if (
            this.courseData.courseScheduleSetting.session_duration_id !== null
          ) {
            duration = this.durationsArray.filter(
              (ele) => ele.id ===
                this.courseData.courseScheduleSetting.session_duration_id
            )
          }
          if (
            this.courseData.courseScheduleSetting.session_frequency_id !== null
          ) {
            frequency = this.frequencyArray.filter(
              (ele) => ele.id ===
                this.courseData.courseScheduleSetting.session_frequency_id
            )
          }

          this.session_frequency =
            duration.length > 0 ? `${frequency[0].name}` : ''
          this.session_duration =
            duration.length > 0 ? `${duration[0].name} ` : ''
        }
      } catch (e) {
        console.log(e)
      }
    }
  },

  directives: {
    'click-outside': {
      bind (el, binding) {
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          /* eslint-disable no-mixed-operators */
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            /* eslint-enable no-mixed-operators */
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },

      unbind (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  }
}
</script>
